var eventListenersForLoadingNCScripts = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend", "ncScriptsLoadNow"];
var nonCriticalScripts = [
    {
        name: 'Slater AIO 2',
        url: '',
        isAsync: true,
        waitForEventName: null,
        afterWaitEventName: null,
        triggerEvents: null
    },
    {
        name: 'Flex Slider Product',
        isCss: true,
        url: '//www.skinssexualhealth.co.uk/cdn/shop/t/52/assets/flexslider-product.css?v=41774363323688775551763984125',
        isAsync: true,
        waitForEventName: null,
        afterWaitEventName: null,
        triggerEvents: null,
    },
    {
        name: 'Popup Styles',
        isCss: true,
        url: '//www.skinssexualhealth.co.uk/cdn/shop/t/52/assets/popup-styles.css?v=158710177352161420821763984125',
        isAsync: true,
        waitForEventName: null,
        afterWaitEventName: null,
        triggerEvents: null,
    }
];

var ncEvents = [];

// Initialize a flag to keep track of whether the createScripts function has been executed
var hasFunctionRun = false;

// Function to be executed only once
function runCreateScriptsOnce() {
    if (!hasFunctionRun) {
        createScripts(nonCriticalScripts);
        // glide JS functions
        showLazyFirstGlideSlide();
        if (typeof glideJS_StartAutoPlay === 'function')
        {
            glideJS_StartAutoPlay();
        }
        hasFunctionRun = true;
    }
}

function showLazyFirstGlideSlide()
{
    var activeSlide = document.querySelector('.glide__slide--active');
    if (activeSlide != null)
    {
        var picture = activeSlide.querySelector('picture');
        swapLazySource(picture);
    }
}

// Add event listeners to trigger the function
eventListenersForLoadingNCScripts.forEach(function (eventName) {
    document.addEventListener(eventName, runCreateScriptsOnce, { once: true });
});

function createScripts(listOfScriptObjs) {

    var resolves = [];
    new Promise(function (resolve, reject) {

        listOfScriptObjs.forEach(function (scriptObj) {

            // css only objects
            if (scriptObj.isCss !== undefined && scriptObj.isCss == true) {
                var link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = scriptObj.url;
                document.body.appendChild(link);
            }

            if (scriptObj.isCss == undefined || scriptObj.isCss == false) {
                ncEvents.push(scriptObj.triggerEvents);
                var script = document.createElement('script');
                script.src = scriptObj.url;
                script.async = scriptObj.isAsync;

                scriptPromise = new Promise(function (scriptResolve, scriptReject) {
                    if (scriptObj.waitForEventName == null) {
                        document.body.appendChild(script);
                        script.onload = function () {
                            if (scriptObj.afterWaitActions !== undefined && scriptObj.afterWaitActions !== null) {
                                scriptObj.afterWaitActions();
                            }
                            scriptResolve(); // resolve this promise only when script downloaded
                        };
                    }
                    else {
                        // script will only load after waiting for somethiing here
                        document.addEventListener(scriptObj.waitForEventName, function () {
                            // waiting has completed, now create this script
                            document.body.appendChild(script);
                            script.onload = function () {
                                if (scriptObj.afterWaitEventName !== undefined && scriptObj.afterWaitEventName !== null) {
                                    var event = new Event(scriptObj.afterWaitEventName);
                                    document.dispatchEvent(event);
                                }
                                if (scriptObj.afterWaitActions !== undefined && scriptObj.afterWaitActions !== null) {
                                    scriptObj.afterWaitActions();
                                }
                            };
                        });
                        scriptResolve(); // resolve this promise now, as script will load only on event listener given
                    }
                });
                resolves.push(scriptPromise);
            }
        });
        resolve();
    }).then(function () {
        Promise.all(resolves)
            .then(function () {
                ncEvents.forEach(function (ncEvent) {
                    if (ncEvent !== null) {
                        try { ncEvent(); } catch (e) { console.log(e); }
                    }
                });
            })
            .catch(function (error) {
                console.error("One or more promises were rejected:", error);
            });
    })

}